import React from 'react';
import { Button } from './index';
import type { ButtonProps } from './index';
import { cn } from '@/utils/formatter';

interface ActionButtonProps extends Omit<ButtonProps, 'isLoading'> {
  isPending?: boolean;
  onClick?: () => void;
}

export default function ActionButton({
  children,
  isPending = false,
  variant,
  size,
  className,
  onClick,
  ...props
}: ActionButtonProps) {
  return (
    <Button
      onClick={
        onClick
          ? (e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              onClick();
            }
          : undefined
      }
      type="button"
      isLoading={isPending}
      variant={variant}
      size={size}
      className={cn(className)}
      {...props}
    >
      {children}
    </Button>
  );
}

export { ActionButton };
